// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"13c393fb","408":"44d2a213","453":"3398875d"}[chunkId] + ".chunk.js";
};